import { Component, HostListener, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { LoginService } from "../../services/login.service";
import { OrganizationLoginService } from "../../services/organization-login.service";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  public newUser = false;
  public loginForm: FormGroup;
  public show: boolean = false
  public errorMessage: any;
  isLoggedIn: boolean = false;
  selectedRole: any;
  roleArray = ['Organization', 'Staff']
  is_checked: string;
  code: any;
  dynamicWidth: number = 370;
  constructor(private fb: FormBuilder, public router: Router, private loginService : LoginService,private organizationLoginService: OrganizationLoginService) {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required]],
      password: ["", Validators.required],
      remember: [false],
      role: ["", [Validators.required]],
      code: [""]
    });
    this.loginService.selectedRole$.subscribe(role => {
      this.selectedRole = role;
      this.loginForm.get('role')?.setValue(role);
    });
    this.organizationLoginService.selectedRole$.subscribe(role => {
      this.selectedRole = role;
      this.loginForm.get('role')?.setValue(role);
    });
    this.passCode('')
  }

  ngOnInit() {
  this.updateWidth();
  if (!sessionStorage.getItem('reloaded')) {
    sessionStorage.setItem('reloaded', 'true');
    window.location.reload();
    return; 
  }
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminName');
  localStorage.removeItem('adminRole');
  const savedRole = localStorage.getItem('selectedRole');
  this.selectedRole = savedRole ? savedRole : 'Staff';
  this.loginForm.get('role')?.setValue(this.selectedRole);
  this.loginService.selectedRole$.next(this.selectedRole);
  this.organizationLoginService.selectedRole$.next(this.selectedRole);
    if(this.selectedRole === 'Staff') {
      if(this.loginService.isLoggedIn()) {
        this.router.navigate(['store/dashboard']);
      }
    } else if(this.selectedRole === 'Organization') {
      if(this.organizationLoginService.isOrganizationLoggedIn()) {
        this.router.navigate(['organization/dashboard']);
      }
    }
    if (this.selectedRole === 'Organization') {
      this.organizationLoginService.googleLogin();
    } 
  }

  @HostListener('window:resize')
  onResize() {
    this.updateWidth();
  }
  
  // Updates the dynamic width based on the screen size
  updateWidth() {
    const screenWidth = window.innerWidth;

    if (screenWidth < 340) {
      this.dynamicWidth = 255;
    }else if (screenWidth < 576) {
      this.dynamicWidth = 312;
    } else {
      this.dynamicWidth = 370; 
    }
  }

  // Handles the login process based on the selected role
  login() {
    if (this.loginForm.valid) {
      let userEmail = this.loginForm.value['email'];
      let userPassword = this.loginForm.value['password'];
      let selectedRole = this.loginForm.value['role'];
      let code = this.loginForm.value['code'];
      localStorage.setItem('selectedRole', selectedRole); 
      if(selectedRole === 'Staff') {
        this.loginService.login(userEmail, userPassword, code);
      } else if(selectedRole === 'Organization') {
        this.organizationLoginService.login(userEmail, userPassword);
      }
    } 
  }

  // Updates the code value in the form when the input changes
  onChangeCode(event: any) {
    const code = event?.target?.value;
    this.passCode(code)
  }

  // Passes the code to the login service for Google login
  passCode(code : any) {
    this.loginService.googleLogin(code); 
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.login();
    }
  }

  isError(control) {
    const data = this.loginForm.get(control);
    return data && (data.touched || data.dirty) && data.invalid;
  }

  showPassword(){
    this.show = !this.show
  }

  // Handles role change events and updates the selected role
  roleChange($event) {
    const selectedRole = $event.target.value;
    this.loginService.selectedRole$.next(selectedRole);
    this.organizationLoginService.selectedRole$.next(selectedRole);
    this.loginForm.get('role')?.setValue(selectedRole);
    localStorage.setItem('selectedRole', selectedRole); 
  }

  // Handles the F2 key press to toggle a specific localStorage value
  handleKeyDown(event: KeyboardEvent): void {
    if (event.key === 'F2') {
      localStorage.setItem('is_show', 'true');
      this.is_checked = localStorage.getItem('is_show') || '';
    }
  }
}
